import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import moment from 'moment';

import { TABLE_NAME, absenceDisplays } from '../helpers/constants';
import firebase from '../helpers/firebase';

const db = firebase.database();

class AbsenceRow extends Component {
  static contextTypes = {
    router: PropTypes.object
  };
  constructor(props, context) {
    super(props, context);

    this.state = {user: {}};
    if (this.props.admin && this.props.absence.userId) {
      db.ref(TABLE_NAME.USERS).child(this.props.absence.userId).once('value').then((snapshot) => {
        let user = snapshot.val();
        user.id = snapshot.key;
        this.setState({ user: user });
      });
    }
  }


  render() {

    const absence = Object.assign({}, this.props.absence);
    absence.user = this.state.user;
    absence.display = {
      date: moment(absence.date).format('YYYY-MM-DD (ddd)'),
      type: absenceDisplays[absence.type],
    }

    const { display: { date, type }, user } = absence;

    return (
      <tr>
        <td>{type}</td>
        { this.props.admin ? <td>
          <Link to={`/admin/users/${user.id}`}>
            {user.name}
          </Link>
        </td> : null }
        <td>{date}</td>
      </tr>
    )
  }

}


export default AbsenceRow;



// WEBPACK FOOTER //
// ./src/components/AbsenceRow.js